import React from "react";
// import { useTranslation } from "react-i18next";
// import LogoKostrad from "../../../assets/images/2026/general/logo-kostrad.png";
// import TextRunWithHonor from "../../../assets/images/2026/general/text-run-with-honor.png";
// import TextTanggalLokasiHero from "../../../assets/images/2026/general/text-tanggal-lokasi-hero.png";
import BtnRegisterNow from "../../../assets/images/2026/general/btn-register-now.png";
// import OrnamentMonas from "../../../assets/images/2026/general/ornament-monas.png";
// import OrnamentPerson from "../../../assets/images/2026/general/ornament-person.png";
// import Logo65Kostrad from "../../../assets/images/2026/general/logo-65-kostrad.png";
import OrnamentDotted from "../../../assets/images/2026/general/ornament-dotted.png";
// import TextKostradRunTitleSection from "../../../assets/images/2026/general/text-kostrad-run-title-section.png";
// import TextTanggalLokasiKostradRun from "../../../assets/images/2026/general/text-tanggal-lokasi-kostrad-run.png";
// import Text5KFunRunKostrad from "../../../assets/images/2026/general/text-5k-fun-run-kostrad.png";
// import Text10KChallengeKostrad from "../../../assets/images/2026/general/text-10k-challenge-kostrad.png";
// import TextTotalHadiah from "../../../assets/images/2026/general/text-total-hadiah.png";
// import BgUangMerah from "../../../assets/images/2026/general/bg-uang-merah.png";
// import Text85Juta from "../../../assets/images/2026/general/text-85-juta.png";
// import Bg5UnitMotor from "../../../assets/images/2026/general/bg-5-unit-motor.png";
import TextRacePackTitle from "../../../assets/images/2026/general/text-race-pack-title.png";
import BgRacePackBaju from "../../../assets/images/2026/general/bg-race-pack-baju.png";
import Top3CardRacePack from "../../../assets/images/2026/general/top-3-card-race-pack.png";
import Bottom3CardRacePack from "../../../assets/images/2026/general/bottom-3-card-race-pack.png";

export default function RacePackSection() {
    // const { t } = useTranslation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (
        <div className="w-full max-md:min-h-[70vh] min-h-fit relative">
            <div className="flex flex-col items-center relative">
                <div id="kostrad-run-title-section" className="relative w-full">
                    {/* OrnamentDotted - spans full width, repeats on x-axis */}
                    <div
                        className="w-full h-[80px] md:h-[120px] absolute top-0 left-0 z-10"
                        style={{
                            backgroundImage: `url(${OrnamentDotted})`,
                            backgroundRepeat: 'repeat-x',
                            backgroundSize: 'auto 100%',
                            backgroundPosition: 'center',
                        }}
                    />
                    {/* TextKostradRunTitleSection - centered on top */}
                    <div className="relative z-20 flex justify-center items-center py-7 md:py-8">
                        <img
                            src={TextRacePackTitle}
                            alt=""
                            className="w-[400px] md:w-[800px] h-auto object-contain"
                        />
                    </div>
                </div>
                <div id="kostrad-run-content-section" className="relative w-full flex flex-col md:flex-row pt-4 md:pt-8">
                    {/* TextKostradRunTitleSection - centered on top */}
                    <div className="relative z-20 flex flex-col justify-center items-center py-8 basis-1/2" id="kostrad-run-content-section-left">
                        <img
                            src={BgRacePackBaju}
                            alt=""
                            className="w-[320px] md:w-[540px] h-auto object-contain"
                        />
                    </div>
                    <div className="relative z-20 flex flex-col justify-center items-center py-8 basis-1/2" id="kostrad-run-content-section-right">
                        <img
                            src={Top3CardRacePack}
                            alt=""
                            className="w-[280px] md:w-[420px] h-auto object-contain"
                        />
                        <img
                            src={BtnRegisterNow}
                            alt=""
                            className="w-32 md:w-52 h-auto object-contain cursor-pointer hover:scale-105 transition-all duration-300 pt-4"
                            onClick={() => window.location.href = "/registration"}
                        />
                    </div>
                </div>
                <div id="kostrad-run-bottom-section" className="relative w-full flex pt-0 md:pt-8 justify-center items-center pb-6 md:pb-12">
                    <img
                        src={Bottom3CardRacePack}
                        alt=""
                        className="w-[360px] md:w-[65vw] h-auto object-contain"
                    />
                </div>
            </div>
        </div>
    );
}
